module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<fieldset> ';
 if(isEmobility) { 
__p+=' <h2 style="text-align: center">'+
((__t=( i18n.tc("RoleApplication", "DEFA e-mobility installer application") ))==null?'':__t)+
'</h2><p>'+
((__t=( companyName ))==null?'':__t)+
' '+
((__t=( i18n.tc("RoleApplication", "has applied to the following DEFA e-mobility access levels through the access application form:") ))==null?'':__t)+
'</p> ';
 } else {
__p+=' <h2 style="text-align: center">'+
((__t=( i18n.tc("RoleApplication", "DEFA Link installer application") ))==null?'':__t)+
'</h2><p>'+
((__t=( companyName ))==null?'':__t)+
' '+
((__t=( i18n.tc("RoleApplication", "has applied to the following DEFA Link access levels through the access application form:") ))==null?'':__t)+
'</p> ';
 } 
__p+=' <ul> ';
 _.each(roles, function(role){ 
__p+=' <li>'+
((__t=( role ))==null?'':__t)+
'</li> ';
 }); 
__p+=' </ul> ';
 if(isEmobility) { 
__p+=' <p>'+
((__t=( i18n.tc("RoleApplication", "Please approve or reject this company with all the mentioned DEFA e-mobility access levels.") ))==null?'':__t)+
'</p> ';
 } else { 
__p+=' <p>'+
((__t=( i18n.tc("RoleApplication", "Please approve or reject this company with all the mentioned DEFA Link access levels.") ))==null?'':__t)+
'</p> ';
 } 
__p+=' </fieldset><fieldset><dl> ';
 if(companyName) { 
__p+=' <dt for="roleApplication-companyName">'+
((__t=( i18n.tc("RoleApplication", "Company name:") ))==null?'':__t)+
'</dt><dd id="roleApplication-companyName">'+
((__t=( companyName ))==null?'':__t)+
'</dd> ';
 } 
__p+=' ';
 if(companyNumber) { 
__p+=' <dt for="roleApplication-companyNumber">'+
((__t=( i18n.tc("RoleApplication", "Company number:") ))==null?'':__t)+
'</dt><dd id="roleApplication-companyNumber">'+
((__t=( companyNumber ))==null?'':__t)+
'</dd> ';
 } 
__p+=' ';
 if(contactEmail) { 
__p+=' <dt for="roleApplication-contactEmail">'+
((__t=( i18n.tc("RoleApplication", "Contact email:") ))==null?'':__t)+
'</dt><dd id="roleApplication-contactEmail">'+
((__t=( contactEmail ))==null?'':__t)+
'</dd> ';
 } 
__p+=' ';
 if(phoneNumber) { 
__p+=' <dt for="roleApplication-phoneNumber">'+
((__t=( i18n.tc("RoleApplication", "Phone number:") ))==null?'':__t)+
'</dt><dd id="roleApplication-phoneNumber">'+
((__t=( phoneNumber ))==null?'':__t)+
'</dd> ';
 } 
__p+=' ';
 if(address1) { 
__p+=' <dt for="roleApplication-address1">'+
((__t=( i18n.tc("RoleApplication", "Adress 1:") ))==null?'':__t)+
'</dt><dd id="roleApplication-address1">'+
((__t=( address1 ))==null?'':__t)+
'</dd> ';
 } 
__p+=' ';
 if(address2) { 
__p+=' <dt for="roleApplication-address1">'+
((__t=( i18n.tc("RoleApplication", "Adress 2:") ))==null?'':__t)+
'</dt><dd id="roleApplication-address1">'+
((__t=( address2 ))==null?'':__t)+
'</dd> ';
 } 
__p+=' ';
 if(postcode) { 
__p+=' <dt for="roleApplication-postcode">'+
((__t=( i18n.tc("RoleApplication", "Post code:") ))==null?'':__t)+
'</dt><dd id="roleApplication-postcode">'+
((__t=( postcode ))==null?'':__t)+
'</dd> ';
 } 
__p+=' ';
 if(city) { 
__p+=' <dt for="roleApplication-city">'+
((__t=( i18n.tc("RoleApplication", "City:") ))==null?'':__t)+
'</dt><dd id="roleApplication-city">'+
((__t=( city ))==null?'':__t)+
'</dd> ';
 } 
__p+=' ';
 if(country) { 
__p+=' <dt for="roleApplication-country">'+
((__t=( i18n.tc("RoleApplication", "Country:") ))==null?'':__t)+
'</dt><dd id="roleApplication-country">'+
((__t=( country ))==null?'':__t)+
'</dd> ';
 } 
__p+=' </dl></fieldset><fieldset class="button-wrap"><button class="danger" data-click="application-reject">'+
((__t=( i18n.tc( "RoleApplication", "Reject" ) ))==null?'':__t)+
'</button> <button class="primary" data-click="application-approve">'+
((__t=( i18n.tc( "RoleApplication", "Approve" ) ))==null?'':__t)+
'</button></fieldset>';
}
return __p;
};
